<template>
    <div class="modal calendar-modal fade" id="eventModal" tabindex="-1" role="dialog" aria-labelledby="eventModal" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="input_title">Sons of Bosses (SOBs) - {{ input_title }}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="date" v-html="formattedDate"></div>
                    <div class="adres-wrap" v-if="input_calendar && input_calendar.address">
                        <div class="address" v-html="input_calendar.address"></div>
                        <div class="sep"></div>
                        <div class="map">
                            <a href="javascript:void(0)" class="map_link" @click="showMap"><span>on Map</span></a>
                        </div>
                    </div>
                    <p v-if="input_calendar" v-html="input_calendar.description"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "CalendarEventsInfoModal",
        props: {
            input_calendar: Object,
            input_title: String,
            input_date: Object
        },
        computed: {
            formattedDate() {
               if (this.input_date) {
                   const { start, end, allDay } = this.input_date

                   const startDate = new Date(start);
                   const endDate = new Date(end);
                   const dateOptions = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric' };
                   const timeOptions = { hour: 'numeric', minute: 'numeric', hour12: true };

                   const date = (date) => date.toLocaleString('en-US', dateOptions)
                   const time = (time) => time.toLocaleString('en-US', timeOptions)

                   if (allDay) return `${date(startDate)} ${time(startDate)} - ${time(endDate)}`

                   return `${date(startDate)} ${time(startDate)} - ${date(endDate)} ${time(endDate)}`
               } else {
                   return null
               }
            }
        },
        methods: {
            showMap() {
                $('#mapModal').modal();
            }
        }
    }
</script>
